import classes from './FormEducation.module.css';
import { useCurrentDataContext } from '../../../contexts/CurrentDataContext';
import { useTranslation } from 'react-i18next';
import FileDropZone from '../../Assets/FileDropZone/FileDropZone';

const FormEducationProfessional = () => {

    const { currentData, setCurrentData } = useCurrentDataContext();

    // Set translation
    const { t } = useTranslation();

    const getAttachmentsText = () => {
        if(currentData?.isRegistered){
            return t('formEducation.educationAttachmentsTitle');
        } else {
            return currentData?.educationId === 7 ? t('formEducation.educationAttachmentsTitleAssistant') : t('formEducation.educationAttachmentsTitleNotRegistered');
        }
    };
    return (
        <>
            {currentData?.educationLevel && (
                <div>
                    <div>{t('formEducation.terhikkiNumber')}</div>
                    <div className={classes.formEducationRow}>
                        <input
                            className={classes.formEducationInput}
                            placeholder={t('formEducation.terhikkiNumber')}
                            value={currentData?.registerNumber || ""}
                            disabled={currentData?.educationId === 7}
                            onChange={(e) => setCurrentData(
                                {
                                    ...currentData,
                                    registerNumber: e.target.value !== "" ? e.target.value : null
                                }
                            )}
                        />

                        <a
                            className={classes.formEducationLink}
                            href='https://julkiterhikki.valvira.fi/'
                            target='_blank'
                            rel='noreferrer noopener'
                        >
                            {t('formEducation.openTerhikkiWebsite')}
                        </a>
                    </div>

                    <div className={classes.formEducationRow}>
                        <input
                            className={classes.formEducationCheckbox}
                            type="checkbox"
                            checked={!currentData.isRegistered}
                            disabled={currentData?.educationId === 7}
                            onChange={() =>
                                setCurrentData(
                                    {
                                        ...currentData,
                                        // If there's something in inputfield when confirming that 
                                        // user doesnt have Terhikki-number, clear inputfield
                                        registerNumber: currentData.isRegistered ? null : currentData.registerNumber,
                                        isRegistered: currentData.isRegistered ? false : true
                                    })
                            }
                        />
                        <div className={classes.formEducationCheckboxText}>
                            {`${t('formEducation.applicantDoesntHaveTerhikkiNumber')}`}
                        </div>
                    </div>

                    <div className={classes.formEducationRowForFile}>
                        <div
                            className={classes.askAttachmentText}
                        >

                            {getAttachmentsText()}
                        </div>
                        <FileDropZone
                            fileType="education"
                        />
                    </div>
                </div>
            )}
        </>
    )
};

export default FormEducationProfessional;